import type { ReactNode } from "react";

interface TagProps {
  children: ReactNode;
  variant?: "accent" | "secondary" | "primary" | "outline";
}

const variantMap = {
  accent: "bg-accent-100/10 text-accent-400 border border-accent-500/30",
  secondary: "bg-secondary-100/10 text-secondary-300 border border-secondary-500/30",
  primary: "bg-primary-100/10 text-primary-300 border border-primary-500/40",
  outline: "bg-transparent text-foreground-600 border border-background-300",
};

export default function Tag({ children, variant = "secondary" }: TagProps) {
  return (
    <span
      className={`inline-flex items-center h-6 px-2.5 rounded-full text-xs whitespace-nowrap ${variantMap[variant]}`}
    >
      {children}
    </span>
  );
}